import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AIPromptAndResponseWithUpdatedUTC } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService): GridSetup<AIPromptAndResponseWithUpdatedUTC> {

	return {
		rowName: { singular: 'Prompt', plural: 'Prompts' },
		getRowKey: row => '' + row.aiPromptId,
		stateKey: 'experience-ai-advisor-prompts-and-responses-grid',
		actions: getActions(dialog),
		buttons: [],
		columns: getColumns(util),
	}
}
